export default {
  confirm: {
    // 确认框提示信息
    cloudDesktopManage: {
      deleteMsg: '删除云桌面({desktopName})，该云桌面删除后将保留在回收站',
      batchDeleteMsg: '删除({num})台云桌面，云桌面删除后将保留在回收站',
      deleteSubMsg: '如果你想恢复该云桌面请前往回收站进行操作',
      stopMsg: '关闭云桌面({desktopName})？',
      batchRevertMsg: '还原({num})台云桌面，云桌面还原后[系统盘数据将永久性丢失]',
      revertMsg: '还原云桌面({desktopName})，云桌面还原后[系统盘数据将永久性丢失]',
      batchStopMsg: '关闭({num})台云桌面？',
      editCloudDesktopStrategyMsg: '编辑云桌面策略,[云桌面编辑后可能导致系统盘数据丢失]',
      cancelLocalDiskMsg: '未勾选使用本地盘将无法使用本地盘，但数据并不会丢失。<br>是否确认修改？'
    },
    userManage: {
      groupDeleteMsg: '删除该({label})用户组吗？删除用户组会把该组下的所有用户转移到默认分组。',
      deleteUser: '删除选中的({num})个用户吗？',
      deleteUserMsg: '删除用户({username})吗？',
      deleteFailTip: '已绑定终端[{terminalName}]，无法删除用户，请到【终端管理】中解除绑定后再删除用户。',
      deleteMultiFailTip: '有多个用户已经绑定终端，无法删除用户，请到【终端管理】中解除绑定后再删除用户。',
      resetPassword: '请确认要重置成初始密码（123456）？',
      applyDesktopConfigMsg:
        '使用该用户组中的云桌面配置，为该组下未创建任何云桌面的普通用户或AD域用户各自创建一个云桌面？',
      confirmEidtUserGroupAuthMsg: '请确认要编辑用户组权限？',
      confirmEidtUserGroupAuthSubMsg: '编辑用户组权限后，本组及所有子组下的全部用户都将拥有({auth})权限',
      addDesktopForDisabledAdUser: '请确认要为禁用的AD域用户添加云桌面？',
      userDeleteMsg: '删除用户({userName})，[用户信息将永久性丢失]，所关联的云桌面删除后将保留在回收站',
      userBatchDeleteMsg: '删除({num})个用户，[用户信息将永久性丢失]，所关联的云桌面删除后将保留在回收站',
      messageLog: {
        deleteMsg: '删除消息({title})',
        batchDeleteMsg: '删除({num})条消息'
      }
    },
    adminManage: {
      userBatchDeleteMsg: '删除({num})个管理员',
      deleteMsg: '删除管理员({userName})'
    },
    idvTerminal: {
      stopMsg: '关闭终端({name})？',
      batchStopMsg: '关闭({num})台终端？',
      rebootMsg: '重启终端({terminalHostName})？',
      batchRebootMsg: '重启({num})台终端？',
      deleteMsg: '删除终端({terminalHostName}),[删除终端将删除终端上所有的数据]',
      batchDeleteMsg: '请确认要删除【{num}】台终端？删除终端管理员将失去对该终端的管理能力',
      recoverMsg:
        '[还原云桌面]将使终端系统还原，删除系统盘的用户个性数据，保留本地盘的数据。<br>确定要对{terminalName}终端执行还原镜像的操作吗？',
      batchRecoverMsg: '请确认要还原【{num}】台终端。',
      initMsg:
        '[终端初始化]将删除终端上保存所有用户数据，并移动该终端到默认分组中。<br>确定要对{terminalName}终端执行初始化的操作吗？',
      batchInitMsg:
        '请确认要初始化【{num}】台终端，初始化终端[将删除终端上保存所有用户数据]，并移动该终端到默认分组中。',
      batchDeleteGroupMsg: '删除终端组： {label}？该组及其子组将被删除，其下所有的终端将被移至默认分组。',
      terminalDiskClear:
        '[D盘清空]将删除用户保存在本地盘及桌面的数据。<br>确定要对{terminalName}终端执行D盘清空的操作吗？',
      batchTerminalDiskClear: '请确认要清空【{num}】台终端的数据盘，清空数据盘[将删除用户保存在本地盘及桌面的数据]。',
      inBeta: '升级公测版本后，终端将重启进行升级！'
    },
    projectManage: {
      delMsg: '删除项目({projectName})'
    },
    settingConfig: {
      deleteMsg: '删除管理员({userName})'
    },
    organizationManagement: {
      memberDelete: '无法删除管理员帐号',
      deleteMemberMsg: '删除成员({display})？确认后该成员将不再属于您的组织。',
      deleteMsg: '请确认要删除组织【{orgName}】？确认后【{orgName}】组织将无法对您进行维护。',
      openMaintenanceMsg: '请确认要开启【{orgName}】的运维权限？确认后【{orgName}】组织将拥有对您的维护权限。',
      closeMaintenanceMsg: '请确认要关闭【{orgName}】的运维权限？确认后【{orgName}】组织将无法对您进行维护。'
    },
    outsideStrategy: {
      usbType: {
        deleteMsg: '删除USB外设类型({usbTypeName})？',
        batchDeleteMsg: '删除({num})个USB外设类型？'
      },
      device: {
        deleteMsg: '删除设备({firmFlag})？',
        batchDeleteMsg: '删除({num})个设备？'
      },
      advancedConfig: {
        deviceDriverConfig: {
          deleteMsg: '删除特定设备驱动配置({firmFlag})？',
          batchDeleteMsg: '删除({num})个特定设备驱动配置？'
        },
        deviceConfigInfo: {
          deleteMsg: '删除特定设备配置({firmFlag})？',
          batchDeleteMsg: '删除({num})个特定设备配置？'
        },
        autoRedirectConfig: {
          deleteMsg: '删除自动重定向配置({firmFlag})？',
          batchDeleteMsg: '删除({num})个自动重定向配置？'
        }
      }
    },
    systemMaintenance: {
      accessComfirmSetting: '终端管理密码开启后，用户对终端进行设置操作需要输入管理员密码',
      accessCancelSetting: '终端管理密码关闭后，用户对终端进行设置操作无需输入管理员密码'
    }
  },
  alert: {
    // 弹出框提示信息
    idvTerminal: {
      deleteFailTip: '已绑定用户[{userName}]，无法删除终端，请确认先解除绑定后再删除终端。',
      deleteMultiFailTip: '有多个终端已绑定用户，请确认先解除绑定后再删除终端。'
    }
  },
  operation: {
    // 按钮不可操作提示信息
    userManage: {
      deletedMsg: '请选择要删除的用户',
      deleteUserGroup: '默认分组不能删除',
      editUserGroup: '默认分组不能编辑',
      addUserGroup: '默认分组不能创建子分组',
      delete: '该用户是启用的AD域用户或其云桌面处于非关闭状态，不可删除',
      recover: '回收站中无该用户云桌面或云桌面个数已达上限',
      desktopAdd: '云桌面个数已达上限，普通或AD域用户3个，访客10个',
      passwordReset: '请选择普通用户重置密码',
      edit: '请选择普通用户或访客用户编辑基本信息',
      treeCreate: 'AD域用户组下不能创建用户组',
      treeDelete: '启用AD域对接时，AD域用户组不能删除',
      movingToGroup: '请选择普通用户或访客移动分组',
      editAdUser: '请选择AD域用户编辑权限',
      editAdUserGroup: '请选择AD域用户组编辑权限',
      goToUnbind: '前往解绑'
    },
    cloudDesktopManage: {
      revert: '请选择已关机的应用分发或个性云桌面',
      close: '请选择已关机的云桌面',
      stop: '请选择运行中的云桌面',
      remote: '请选择运行中的云桌面',
      editStrategy: '请选择已关机的普通用户或AD域用户的云桌面',
      errorRecover: '请选择故障的云桌面'
    },
    idvTerminal: {
      remoteAutoAgreeTip: '用户开启协助',
      online: '请选择在线的终端',
      initialize: '终端离线，不允许初始化',
      recover: '终端在线且云桌面处于关闭、故障、运行中状态时可还原云桌面',
      reboot: '终端离线，不允许重启',
      delete: '终端在线，不允许删除',
      stop: '终端离线，不允许关机',
      edit: '终端初始化配置未完成，不允许编辑',
      changeGroup: '请选择要做移动分组的终端',
      batchDelete: '请选择要删除的终端',
      batchRecover: '请选择在线且云桌面处于关闭、故障、运行中状态的终端',
      batchDiskClear: '请选择在线并启用本地盘的终端清空数据盘',
      batchInit: '请选择在线终端进行初始化',
      remote: '请选择在线且云桌面在运行中的终端进行远程协助',
      idvDiskClear: '请选择在线终端清空数据盘',
      idvNoDisk: '请选择有本地盘的终端清空数据盘',
      notSupportRemoteAssist: 'GuestTool版本低，不支持远程协助',
      notReayForRemoteAssist: '远程桌面未就绪',
      shareStateTip: '终端已开启部署配置分享',
      unDeployTip: '终端未部署',
      terminalSettingShare: '请选择已部署终端开启部署配置分享',
      inBeta: '请选择存在公测版本的终端',
      inBetaed: '请选择没有进入公测版本的终端'
    },
    settingConfig: {
      delete: '用户在线，不允许删除'
    },
    organizationManagement: {
      deleteTip: '请选择运维权限关闭的组织进行删除',
      transferAuthorityTip: '无成员可移交',
      enperienceModeTip: '暂不支持体验本功能'
    },
    outsideStrategy: {
      usbDelete: '请选择非默认的且不含设备的外设类型',
      usbEdit: '请选择非默认的外设类型',
      device: '请选择非默认设备',
      deviceType: '请选择非默认的设备',
      usbAtleastOne: '请至少选择一条非默认外设类型',
      usbChooseOne: '请选择一条非默认外设类型',
      deviceAtleastOne: '请至少选择一条非默认设备',
      deviceChooseOne: '请选择一条非默认设备',
      usbTypeDisabledTips: '该外设类型是默认数据，不可操作',
      deviceDisabledTips: '该设备是默认数据，不可操作'
    }
  },
  permission: {
    access_denied: '没有相关权限'
  },
  form: {
    not_empty: '必填项',
    not_empty_phone: '手机不能为空',
    not_empty_pass: '必填项',
    not_empty_verify_code: '验证码不能为空',
    not_empty_verify_password: '密码不能为空',
    verify_pass_len: '密码由6~15个字符组成',
    verify_pass_contain: '密码需包含数字和字母(支持英文，数字和下划线)，区分大小写',
    verify_phone_contain: '您输入的手机号格式有误',
    verify_term_service: '请勾选我已阅读并同意服务条款',
    long32_limit: '长度不能超过32个字符',
    long64_limit: '长度不能超过64个字符',
    cn_en_limit: '仅支持中英文',
    org_name_repeat: '组织名称已存在，请输入其他名称',
    pass_not_same: '新密码不能与原密码相同，请更换其他密码',
    real_name_limit: '您输入的姓名包含特殊字符，请检查并重新输入',

    verifyCodeTip: '请输入您的短信验证码',
    smsTip: '已发送验证码至{phone}'
  }
}
